import styled from 'styled-components';

import { CHECKBOX_STATUS, StaticCheckbox } from 'ui/checkbox';

import { BasicOption } from './BasicOption';
import { BasicOptionProps, SelectValueType } from './types';

const StyledCheckbox = styled(StaticCheckbox)``;

export function CheckableOption<TValue extends SelectValueType = string>(
  props: BasicOptionProps<TValue>,
) {
  const { isSelected, isDisabled } = props;

  return (
    <BasicOption
      style={{ pointerEvents: `${isDisabled ? 'none' : 'auto'}` }}
      {...props}
      Prefix={
        <StyledCheckbox
          id={`checkbox-${props.id}`}
          isDisabled={isDisabled}
          status={isSelected ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
        />
      }
    />
  );
}
